import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsHierarchyAllocationAssetSegmentsQueryParams,
  FamsHierarchyAllocationAssetSegmentsResponse,
  FamsHierarchyAllocationDashboardQueryParams,
  FamsHierarchyAllocationDashboardResponse,
  FamsHierarchyAllocationDeviationQueryParams,
  FamsHierarchyAllocationDeviationResponse,
  FamsHierarchyAllocationObjectOptionsResponse,
} from './types/hierarchy-allocation';

const request = createAppRequest();

export async function getFamsHierarchyAllocationObjectOptions(
  params?: Pick<
    FamsHierarchyAllocationDashboardQueryParams,
    'snapshotDate' | 'objectType' | 'objectKey' | 'keyword'
  >,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAllocationObjectOptionsResponse>(
    '/bff/fams/hierarchy-allocation/object-options',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getFamsHierarchyAllocationDashboard(
  params?: FamsHierarchyAllocationDashboardQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAllocationDashboardResponse>(
    '/bff/fams/hierarchy-allocation/dashboard',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getFamsHierarchyAllocationDeviation(
  params?: FamsHierarchyAllocationDeviationQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAllocationDeviationResponse>(
    '/bff/fams/hierarchy-allocation/deviation',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getFamsHierarchyAllocationAssetSegments(
  params?: FamsHierarchyAllocationAssetSegmentsQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAllocationAssetSegmentsResponse>(
    '/bff/fams/hierarchy-allocation/asset-segments',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}
